import { FileCopy } from "@mui/icons-material";
import { Box, List, ListItemButton, ListItemIcon, ListItemText, MenuItem, Popover, TextField, Typography } from "@mui/material";
import React from "react";
import Service from "../../../util/Service";


export default function KanbanCopiarTemplatePopover(props) {
    const {action, cartao} = props;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const openUser = Boolean(anchorEl);
    const id = openUser ? 'simple-popover' : undefined;

    const [filtro, setFiltro] = React.useState('');
    const [templates, setTemplates] = React.useState();

    React.useEffect(()=>{
        if( openUser){
            console.log('>>>KanbanCopiarTemplatePopover<<<', openUser);
            buscaTemplateKanban();
        }
    }, [openUser])

    function buscaTemplateKanban(){
        Service.GET("/api/projeto/kanban/allTemplate").then(r => setTemplates(r))
    }
    function handleListItemClick(e, row){
        console.log('>>>handleListItemClick<<<', row);
        console.log( cartao );

        const dado = {
            idTemplate: row.id,
            idCard: cartao.id
        }

        Service.POST("/api/security/projeto/kanban/copiaDoTemplate", dado).then( r =>{
            console.log( r );
            if( r.success){
                if( action) action(r.dado);
            }else{
                alert( r.msg );
            }
        })
        
    }
    return (
        <React.Fragment>
            <MenuItem onClick={(e) => setAnchorEl(e.currentTarget)}>
                <ListItemIcon size='small'>
                    <FileCopy fontSize="small" />
                </ListItemIcon>
                Copiar do template
            </MenuItem>
            <Popover
                id={id}
                open={openUser}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Box
                    sx={{
                        marginLeft: "5px",
                        marginRight: "5px",
                        my: 1,
                        minWidth: '300px'
                    }}>
                    <Typography sx={{ p: 2 }}>Escolha Template</Typography>
                    <TextField id="id_filtro" label="Filtro" variant="outlined" fullWidth size='small'
                        value={filtro} onChange={(e) => setFiltro(e.target.value)}
                    />
                    <List component="nav" dense={true}
                        sx={{
                            width: '100%',
                            maxWidth: 360,
                            bgcolor: 'background.paper',
                            position: 'relative',
                            overflow: 'auto',
                            maxHeight: 180,
                            '& ul': { padding: 0 },
                        }}
                    >
                        {templates && templates.map((row) => (
                            <ListItemButton key={row.id}
                                onClick={(event) => handleListItemClick(event, row)}
                            >
                                <ListItemText
                                    primary={row.nome}
                                    secondary={"Esforço estimado: "+row.esforco+" horas."}
                                />
                            </ListItemButton>
                        ))}
                    </List>
                </Box>
            </Popover>
        </React.Fragment>
    );
}